import { SubscriptionTiers } from 'state/subscription/SubscriptionTypes';

export enum AssetTypes {
   Sensation = 'Sensation',
   Waveform = 'Waveform',
}

export interface Asset {
   _id: string;
   name: string;
   description: string;
   type: AssetTypes;
   tier: SubscriptionTiers;
   bytes: number[];
   active?: boolean;
   createdBy: string;
   updatedAt?: string;
}

export interface Assets {
   sensations: Asset[];
   waveforms: Asset[];
}

export interface Assets {
   sensations: Asset[];
   waveforms: Asset[];
}

export interface GetAssetsResponse {
   assets: Asset[];
}

export interface GetAssetResponse {
   asset: Asset;
}

export interface CreateAssetRequest {
   name: string;
   description: string;
   type: AssetTypes;
   tier: SubscriptionTiers | null | undefined;
   bytes: number[];
   active?: boolean;
}

export interface CreateAssetResponse {
   createdAsset: Asset;
}

export interface CreateWaveformRequest {
   name: string;
   tier: SubscriptionTiers | undefined;
   bytes: number[];
}

export interface CreateSensationRequest extends CreateWaveformRequest {
   description: string;
}

export interface Favorite {
   _id: string;
   name: string;
   mode: PlayerModes;
   waveform?: Asset;
   sensation?: Asset;
   duration: number; // minutes
}

export enum PlayerModes {
   Ambient = 'Ambient',
   Follower = 'Music Follower',
   Sensation = 'Sensation',
   None = 'Media Only',
}

export interface UpdateAssetRequest {
   name?: string;
   description?: string;
   type?: AssetTypes;
   tier?: SubscriptionTiers;
   bytes?: number[];
   active?: boolean;
   _id?: string;
}

export interface UpdateAssetResponse {
   updatedAsset: Asset;
}

export type Filter = SubscriptionTiers | boolean | null;

export type StateItems = 'sensations' | 'waveforms' | 'customers' | 'admins';
